import type { ReactNode } from "react";
import styles from "./section.module.css";

export function SectionActions({ children }: { children: ReactNode }) {
  return <div className={styles.actions}>{children}</div>;
}
